import React, { useEffect }  from 'react'
import { connect } from 'react-redux'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import { LoadingPage, LoadingTest, VRPage, Testing, TestingCards, TestingPopupLayer, TestingCork, Splash, SplashSplit, AudioIntro, Map, ProductDetailPage } from './pages'
import { getNetworkDownloadSpeed } from './utils'
import {  de, en, es, fi, fr, nl, pl, pt, ru, sv, it } from './assets/translations'
import { store } from './effects/store'

const whyDidYouRender = require('@welldone-software/why-did-you-render')
whyDidYouRender(React, { trackAllPureComponents: false, logOnDifferentValues: true })

const CustomRoute = (props) => {
  return <Route {...props} />
}

export const messages = {
  de, en, es, fi, fr, nl, pl, pt, ru, sv, it
}
const App = () => {

  useEffect(() => {
    getNetworkDownloadSpeed()
  }, [])

  const locale =  store.getState().app.locale;

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <Router>
        <React.Suspense fallback={<LoadingPage redirect={false} />}>
          <Switch>
            <CustomRoute exact component={VRPage} path="/vr/:model/:pano" useChat={true} />
            <CustomRoute exact component={ProductDetailPage} path="/product-detail" />
            <CustomRoute exact component={TestingCards} path="/testing-cards" />
            <CustomRoute exact component={TestingPopupLayer} path="/testing-popup-layer" />
            <CustomRoute exact component={TestingCork} path="/testing-cork" />
            <CustomRoute exact component={LoadingTest} path="/testing-loading" />
            <CustomRoute exact component={AudioIntro} path="/audio-intro" />
            <CustomRoute exact component={Testing} path="/testingCards" />
            <CustomRoute exact component={Splash} path="/splash" />
            <CustomRoute exact component={SplashSplit} path="/splash-split" />
            <CustomRoute exact component={Map} path="/map" />
            <CustomRoute exact component={LoadingPage} path="/:id" />
            <CustomRoute exact component={LoadingPage} path="/" />
          </Switch>
        </React.Suspense>
      </Router>
     </IntlProvider>
  )
}


const mapStateToProps = ({ app }) => {
  const { locale } = app
  return { locale }
}

export default connect(mapStateToProps, null)(React.memo(App))
